// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"slug_gridWrapper__w4fkX"};